// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Spread$Showside from "../utils/Spread.bs.js";
import MergedRef from "@react-hook/merged-ref";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as EditorLayerItem$Showside from "./EditorLayerItem.bs.js";
function LauncherWithAnchorHighlight(Props) {
  var highlightRef = Props.highlightRef;
  var fwdRef = Props.fwdRef;
  var children = Props.children;
  var ref = React.useRef(null);
  var mergedRef = fwdRef !== undefined ? MergedRef(ref, fwdRef) : ref;
  var match = React.useState(function () {});
  var setHighlightedCategoryId = match[1];
  Belt_Option.forEach(highlightRef, function (ref) {
    ref.current = function (id) {
      Curry._1(setHighlightedCategoryId, function (param) {
        return id;
      });
    };
  });
  return React.createElement(EditorLayerItem$Showside.make, {
    kind: "menubar",
    fwdRef: ReactDOMUtils$Showside.Ref.domRef(mergedRef),
    className: CSS$Showside.prefix("w-full relative pointer-events-auto"),
    children: React.createElement(Spread$Showside.make, {
      props: {
        isNested: true,
        highlightedCategoryId: match[0]
      },
      children: children
    })
  });
}
LauncherWithAnchorHighlight.displayName = "LauncherWithAnchorHighlight";
var make = LauncherWithAnchorHighlight;
export { make };
/* react Not a pure module */